import type { InfractionMetricFilter } from "../types/infraction.types";

export const INFRACTION_METRIC_FILTER = {
	ALL: "all",
	CRITICAL: "critical",
	AWAITING_INDICATION: "awaiting_indication",
	NIC_RISK: "nic_risk",
	PENDING_TOTAL: "pending_total",
} as const;

export type InfractionMetricFilterKey =
	(typeof INFRACTION_METRIC_FILTER)[keyof typeof INFRACTION_METRIC_FILTER];

export const INFRACTION_METRIC_CARDS: {
	key: InfractionMetricFilter;
	title: string;
	subtitle: string;
}[] = [
	{
		key: INFRACTION_METRIC_FILTER.CRITICAL,
		title: "Críticas",
		subtitle: "Indicações e/ou Pagamentos vencendo",
	},
	{
		key: INFRACTION_METRIC_FILTER.AWAITING_INDICATION,
		title: "Aguardando indicação",
		subtitle: "Responsabilidade do condutor",
	},
	{
		key: INFRACTION_METRIC_FILTER.NIC_RISK,
		title: "Risco de multa NIC",
		subtitle: "Multas por Não Indicação de Condutor",
	},
	{
		key: INFRACTION_METRIC_FILTER.PENDING_TOTAL,
		title: "Valor total pendente",
		subtitle: "Guia de Pagamento Disponível",
	},
];
